import React from "react";
import { Star, ExternalLink } from "lucide-react";
import { BRAND, REVIEW_PLACEHOLDERS } from "@/lib/brand";

export default function Reviews() {
  return (
    <section data-testid="reviews-section" id="reviews" className="py-16 md:py-24 bg-bone">
      <div className="container-x">
        <div className="flex flex-wrap items-end justify-between gap-4">
          <div className="max-w-2xl">
            <h2 className="text-[32px] md:text-[44px] font-extrabold text-navy">What families say</h2>
            <div className="mt-3 flex items-center gap-3">
              <div className="flex">
                {[0,1,2,3,4].map(i => <Star key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" />)}
              </div>
              <div className="text-ink/80 font-semibold">{BRAND.rating}★ · {BRAND.ratingCount} Google reviews</div>
            </div>
          </div>
          <a href="https://www.google.com/search?q=velixa+health+reviews" target="_blank" rel="noopener noreferrer" className="btn-outline-navy text-[14.5px]">
            Read all reviews on Google <ExternalLink className="w-4 h-4" />
          </a>
        </div>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          {REVIEW_PLACEHOLDERS.map((r, i) => (
            <article key={i} data-testid={`review-${i}`} className="bg-white rounded-2xl border border-navy/10 p-6 shadow-soft">
              <div className="flex mb-3">{Array.from({length: r.stars}).map((_,j) => <Star key={j} className="w-4 h-4 fill-yellow-400 text-yellow-400" />)}</div>
              <p className="text-ink/85 text-[15.5px] leading-relaxed">"{r.quote}"</p>
              <div className="mt-4 text-[13px] font-semibold text-navy">{r.name || "— Placeholder review —"}</div>
              {r.area && <div className="text-[12px] text-ink/60">{r.area}</div>}
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
